import axios from 'axios'
import apis from './apis'
import config from '../common/config'
import functions from '../common/functions'
import store from '../store'
import { Notify, Dialog } from 'vant'
import qs from 'qs'

export default function f(api_name, data = {}) {
    let debug = new functions.DEBUG('api')
    let api = apis[api_name]
    if (api === undefined) {
        debug.log('failed', { api_name })
        debug.finish()
        throw '未定义的接口：' + api_name
    }
    let method = api.method
    let url = config.backend_url + api.url
    debug.log('init', { name: api_name, method, url })

    // 检查是否是文件上传
    const isFileUpload = api.isFile === true

    // 如果不是文件上传，添加token参数
    let params = {}
    if (!isFileUpload && api.token) {
        params = { user_id: store.state.user_id, token: store.state.token }
    }

    // 对于GET请求，将data中的参数添加到params中
    if (method == 'GET' && !isFileUpload) {
        for (let key in data) {
            params[key] = data[key]
        }
    }

    return new Promise((resolve, reject) => {
        debug.log('running')

        // 如果是文件上传，使用FormData
        let requestConfig = {
            url,
            method,
            data,
            params,
            paramsSerializer: (params) => qs.stringify(params, { indices: false })
        }

        // 如果是文件上传，设置正确的Content-Type
        if (isFileUpload) {
            // 对于FormData，不要手动设置Content-Type，让浏览器自动设置
            // 否则会缺少boundary参数
            // 同时将token作为FormData的一部分
            if (api.token) {
                if (data instanceof FormData) {
                    // 确保user_id和token存在
                    if (!store.state.user_id || !store.state.token) {
                        console.error('用户未登录或token已过期')
                        reject({ message: '用户未登录或token已过期' })
                        return
                    }
                    data.append('user_id', store.state.user_id)
                    data.append('token', store.state.token)
                }
            }
        }

        axios(requestConfig).then(res => {
            debug.log('finish', { http_status: res.status })
            if (res.status == 200) {
                resolve(res.data)
                debug.log('success', res.data)
            } else {
                reject(res.data)
                debug.log('failed', { http_status: res.status, detail: res.data.detail, message: res.data.message })
                Notify({ type: 'danger', message: `[${res.status}]接口调用错误：${res.data.message}` })
            }
            debug.finish()
        }).catch(res => {
            reject(res)
            res = res.response
            debug.log('failed', { http_status: res.status, detail: res.data.detail, message: res.data.message })
            Notify({ type: 'danger', message: `[${res.status}]接口调用错误：${res.data.message}` })
            debug.finish()
        })
    })
}
